/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Tiles_SubtitleInputs */

const en_ui_thresholds_tiles_subtitle = /** @type {(inputs: Ui_Thresholds_Tiles_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap a value to change it from today on.`)
};

const de_ui_thresholds_tiles_subtitle = /** @type {(inputs: Ui_Thresholds_Tiles_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipp auf einen Wert, um ihn ab heute zu ändern.`)
};

/**
* | output |
* | --- |
* | "Tap a value to change it from today on." |
*
* @param {Ui_Thresholds_Tiles_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_tiles_subtitle = /** @type {((inputs?: Ui_Thresholds_Tiles_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Tiles_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_tiles_subtitle(inputs)
	return de_ui_thresholds_tiles_subtitle(inputs)
});